import { Overmind } from './Overmind';
import * as utils from './utils';
export function createOvermindSSR(config) {
    const ssr = new Overmind(config, {
        devtools: false,
    }, {
        mode: utils.MODE_SSR,
    });
    const mutationTree = ssr.proxyStateTreeInstance.getMutationTree();
    ssr.state = mutationTree.state;
    ssr.hydrate = () => {
        return mutationTree.flush().mutations;
    };
    return ssr;
}
//# sourceMappingURL=OvermindSSR.js.map